export default "__VITE_ASSET__B3ZzBOEk__"